import React, { useEffect } from 'react';
import { useStore } from "../../../../state/useNotificationStore";
import SuccessNotification from '../component/Success';
import ErrorNotification from '../component/Error';
import {EmptyIcon} from "../../../../assets/icons/NotificationsEmptyIcon"
 

const Card = () => {
  const notifications = useStore( (state) => state?.notifications);

  const batchUpdateNotifications = useStore( (state) => state?.batchUpdateNotifications);

  const markAllAsRead = () => {   
    const updatedNotifications = notifications?.map( (notification) => ( { ...notification, isRead: true } ));
    console.log(updatedNotifications)
   batchUpdateNotifications( updatedNotifications );
  };

  return (
    <div className=''>
      <div className="flex flex-col gap-5"> 
        {notifications?.length < 1 || !notifications ? (
          <>
         <div className=" flex flex-col items-center justify-center gap-10 ml-[5em] xl:ml-[2em] lg:ml-[1em] md:ml-[1em]">
            <EmptyIcon />
            <div className="flex flex-col items-center justify-center ">
              <h3 className="text-[18px] font-bold">{"You're up to date"}</h3>
              <p>You do not have any new notifications.</p>
            </div>
          </div>
          </>
        ) :
        (
          <>
          <div className="flex flex-row-reverse">
        <p onClick={ markAllAsRead } className="text-blue-900 cursor-pointer">
            <u >Mark all as read</u>
          </p>          
        </div>
        
        {notifications?.map(( notification ) =>
          notification?.type === 'success' ? (
            <SuccessNotification key={notification.id} notification={notification} />
          ) : (
            <ErrorNotification key={notification.id} notification={notification} />
          )
        )}
          </>
        )       
        }
      </div>
    </div>
  );
};

export default Card
